import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

// const [data, setData] = useState('')
const initialState = {
    isLogin: false,
    instructions: {},
    toastData: {},
};

const homeSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setInstructionsById(state, action) {
            state.instructions = action.payload;
        },
        settoastData(state, action) {
            state.toastData = action.payload;
        },
    },
});

export const { settoastData, setInstructionsById } = homeSlice.actions;

export const InstructionsgetById = (id) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_URL}/journal/instructionToAuthor/${id}`).then((res) => {
        // dispatch(settoastData({ status: true, message: "You are Loged in !" }));
        dispatch(setInstructionsById(res?.data));
        // localStorage.setItem("user", JSON.stringify(res.data))
    })
        .catch((err) => {
            dispatch(settoastData({ status: false, message: err?.response?.data }));
        })
    return response;
}
const instructionsReducer = homeSlice.reducer;

export default instructionsReducer;
